import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

import { getUrl } from "../helpers/url";

function Redirect() {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const page = searchParams.get("page");
    const account = searchParams.get("account");
    const paymentStatus = searchParams.get("paymentStatus");
    const plan = searchParams.get("plan");

    if (page && account) {
      window.open(
        `${getUrl("REACT_APP_REDIRECT")}?page=${page}&account=${account}`,
        "_self"
      );
    }
    if (paymentStatus) {
      window.opener.postMessage({ paymentStatus, plan }, "*");
      window.close();
    }
    // eslint-disable-next-line
  }, []);

  return <div></div>;
}

export default Redirect;
